export enum FulfillmentLineDisplayStatusType {
    NotScheduled = "NotScheduled",
    PartiallyScheduled = "PartiallyScheduled",
    InProgress = "InProgress",
    Scheduled = "Scheduled",
    PickupInProgress = "PickupInProgress",
    PickedUp = "PickedUp",
    DestinationInProgress = "DestinationInProgress",
    InTransit = "InTransit",
    OnHold = "OnHold",
    Cancelled = "Cancelled",
    Pending = "Pending",
    PartiallyDelivered = "PartiallyDelivered",
    PartiallyPickedUp = "PartiallyPickedUp"
}
